import psl, { ParsedDomain } from "psl";

export const fetchDomain = () => {
	const url = window.location.toString();
	const baseUrl = new URL(url).hostname;
	const parsedUrl = psl.parse(baseUrl) as ParsedDomain;
	return parsedUrl.domain || "localhost";
};
